import { render, staticRenderFns } from "./FormularioEditBase.vue?vue&type=template&id=15a979d8&scoped=true"
import script from "./FormularioEditBase.vue?vue&type=script&lang=js"
export * from "./FormularioEditBase.vue?vue&type=script&lang=js"
import style0 from "./FormularioEditBase.vue?vue&type=style&index=0&id=15a979d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a979d8",
  null
  
)

export default component.exports